export const Vehicles = [
  {
    make: "ford",
    model: "ranger",
    paintColor: "pspc0004sspc0256",
    name: "FORD RANGER",
    variant: "PHEV XLT",
    engineDesc: "PETROL - Premium ULP",
    transmission: "Automatic",
    body: "UTE",
    range: "0",
    fuelConsumption: "49km",
    weeklyPrice: "362",
    cardColor: "gray",
  },
  {
    make: "tesla",
    model: "model-y",
    paintColor: "pspc0256",
    name: "TESLA MODEL Y",
    variant: "Rear-Wheel Drive",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SUV",
    fuelConsumption: "0",
    range: "510km",
    weeklyPrice: "212",
    cardColor: "gray",
  },
  {
    make: "mitubishi",
    model: "outlander",
    paintColor: "pspc0256sspc0004",
    name: "MITSUBISHI OUTLANDER",
    variant: "ES",
    engineDesc: "PETROL - UNLEADED ULP",
    transmission: "Constantly Variable Transmission",
    body: "SUV",
    range: "0",
    fuelConsumption: "7.5L/100KM",
    weeklyPrice: "244",
    cardColor: "gray",
  },
  {
    make: "byd",
    model: "shark-6",
    paintColor: "pspc0058",
    name: "BYD SHARK 6",
    variant: "Premium",
    engineDesc: "PETROL - PREMIUM ULP",
    transmission: "AUTOMATIC",
    body: "UTE",
    range: "0",
    fuelConsumption: "100KM",
    weeklyPrice: "281",
    cardColor: "gray",
  },
  {
    make: "tesla",
    model: "model-3",
    paintColor: "pspc0297",
    name: "TESLA MODEL 3",
    variant: "Rear-Wheel Drive",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SEDAN",
    fuelConsumption: "0",
    range: "629km",
    weeklyPrice: "209",
    cardColor: "gray",
  },
  {
    make: "mg",
    model: "mg4",
    paintColor: "pspc0041",
    name: "MG MG4",
    variant: "Excite 51 125kW",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "HATCHBACK",
    range: "405km",
    fuelConsumption: "0",
    weeklyPrice: "154",
    cardColor: "gray",
  },
  {
    make: "toyota",
    model: "landcruiser",
    paintColor: "pspc0004sspc0146",
    name: "TOYOTA LANDCRUISER",
    variant: "GX",
    engineDesc: "DIESEL",
    transmission: "SPORTSAUTOMATIC",
    body: "SUV",
    range: "0",
    fuelConsumption: "8.9L/100KM",
    weeklyPrice: "506",
    cardColor: "gray",
  },
  {
    make: "ford",
    model: "everest",
    paintColor: "pspc0004sspc0256",
    name: "FORD EVEREST",
    variant: "Ambiente",
    engineDesc: "DIESEL",
    transmission: "SPORTS AUTOMATIC",
    body: "SUV",
    range: "0",
    fuelConsumption: "7.1L/100km",
    weeklyPrice: "305",
    cardColor: "gray",
  },
  {
    make: "isuzu",
    model: "mu-x",
    paintColor: "pspc0256",
    name: "ISUZU MU-X",
    variant: "LS-M",
    engineDesc: "DIESEL",
    transmission: "SPORTS AUTOMATIC",
    body: "SUV",
    range: "0",
    fuelConsumption: "7.4L/100km",
    weeklyPrice: "282",
    cardColor: "gray",
  },
  {
    make: "byd",
    model: "sealion-7",
    paintColor: "pspc0058",
    name: "BYD SEALION 7",
    variant: "Premium",
    engineDesc: "ELECTRIC",
    transmission: "AUTOMATIC",
    body: "SUV",
    range: "567KM",
    fuelConsumption: "0",
    weeklyPrice: "193",
    cardColor: "gray",
  }
];